import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import * as React from "react";
import { NavLink } from "..";

var NavItem = function NavItem(_ref) {
  var _item$translation, _item$translation2;

  var hideOverlay = _ref.hideOverlay,
      children = _ref.children,
      imageUrl = _ref.imageUrl,
      isScrolled = _ref.isScrolled,
      item = _objectWithoutProperties(_ref, ["hideOverlay", "children", "imageUrl", "isScrolled"]);

  var content = (children === null || children === void 0 ? void 0 : children.length) ? React.createElement("ul", null, children.map(function (subItem, i) {
    return subItem && React.createElement(NavItem, _extends({
      key: i
    }, subItem));
  })) : null;
  return React.createElement("li", {
    className: "nav-item"
  }, React.createElement(NavLink, {
    item: item,
    onClick: function onClick() {
      window.scrollTo({
        behavior: "smooth",
        top: 100
      });

      if (hideOverlay) {
        hideOverlay();
      }
    }
  }, imageUrl && React.createElement("div", {
    className: "nav-item__image",
    style: {
      backgroundImage: "url(".concat(imageUrl, ")")
    }
  }, React.createElement("div", {
    className: "nav-item__image-overlay"
  }), isScrolled && React.createElement("span", {
    className: "nav-item__title"
  }, ((_item$translation = item.translation) === null || _item$translation === void 0 ? void 0 : _item$translation.name) || item.name)), !isScrolled && React.createElement("span", {
    className: "nav-item__title"
  }, ((_item$translation2 = item.translation) === null || _item$translation2 === void 0 ? void 0 : _item$translation2.name) || item.name)), content);
};

export default NavItem;